
export default [
  {
    path: 'produccion',
    name: 'empresa.produccion',
    component: () => import('@/views/empresa/produccion/ProduccionEmpresaLayout.vue'),
    meta: { modulo: 'produccion' },
    children: [
      {
        path: '',
        name: 'empresa.produccion.home',
        component: () => import('@/views/empresa/produccion/ProduccionEmpresaDash.vue'),
      },

      // 🗂️ Cola de trabajo del operario
      {
        path: 'cola',
        name: 'empresa.produccion.cola',
        component: () => import('@/views/empresa/produccion/cola/ColaProduccion.vue'),
      },
      // 📊 Plan consolidado
      {
        path: 'plan',
        name: 'empresa.produccion.plan',
        component: () => import('@/views/empresa/produccion/plan/PlanProduccion.vue'),
      },

      // 🏭 Órdenes de producción
      {
        path: 'ordenes',
        name: 'empresa.produccion.orden.listado',
        component: () => import('@/views/empresa/produccion/orden/OrdenProduccionHome.vue'),
      },
      {
        path: 'ordenes/nueva',
        name: 'empresa.produccion.orden.registrar',
        component: () => import('@/views/empresa/produccion/orden/OrdenProduccionRegistrar.vue'),
      },
      {
        path: 'ordenes/:id',
        name: 'empresa.produccion.orden.consultar',
        component: () => import('@/views/empresa/produccion/orden/OrdenProduccionConsultar.vue'),
      },

      // 📋 Recetas
      {
        path: 'recetas',
        name: 'empresa.produccion.receta.listado',
        component: () => import('@/views/empresa/produccion/receta/RecetaHome.vue'),
      },
      {
        path: 'recetas/nueva',
        name: 'empresa.produccion.receta.registrar',
        component: () => import('@/views/empresa/produccion/receta/RecetaRegistrar.vue'),
      },
      {
        path: 'recetas/:id/editar',
        name: 'empresa.produccion.receta.editar',
        component: () => import('@/views/empresa/produccion/receta/RecetaRegistrar.vue'),
      },
      {
        path: 'recetas/:id',
        name: 'empresa.produccion.receta.consultar',
        component: () => import('@/views/empresa/produccion/receta/RecetaConsultar.vue'),
      },

      // ⚙️ Máquinas
      {
        path: 'maquinas',
        name: 'empresa.produccion.maquina.listado',
        component: () => import('@/views/empresa/produccion/maquina/MaquinaHome.vue'),
      },
    ],
  },
];
